<form [formGroup]="pricingForm" (ngSubmit)="save()" class="pricing-settings-form">
  <div class="settings-section">
  <div class="settings-section-header">EXTRAS</div>
  <div class="price-row">
    <mat-form-field class="price-duty" floatLabel="always">
      <mat-label>DUTY</mat-label>
      <span matPrefix>$&nbsp;</span>
      <input matInput type="number" min="0" step="0.01" formControlName="dutyAmount">
    </mat-form-field>
    <mat-form-field class="price-pads" floatLabel="always">
      <mat-label>NOSEPADS</mat-label>
      <span matPrefix>$&nbsp;</span>
      <input matInput type="number" min="0" step="0.01" formControlName="nosepadsInstallAmount">
    </mat-form-field>
    <mat-form-field class="price-drill" floatLabel="always">
      <mat-label>DRILL</mat-label>
      <span matPrefix>$&nbsp;</span>
      <input matInput type="number" min="0" step="0.01" formControlName="drillMountAmount">
    </mat-form-field>
    <mat-form-field class="price-fee" floatLabel="always">
      <mat-label>RESTOCK</mat-label>
      <input matInput type="number" min="0" max="100" step="0.01" formControlName="restockingFeePercent">
      <span matSuffix>&nbsp;%</span>
    </mat-form-field>
  </div>
  <p class="materials-hint">
    Duty is the fallback for older orders. Nosepads and drill mount are added to Custom. Restocking fee is the default on RETURN.
  </p>
  </div>
  <div class="settings-section">
  <div class="settings-section-header">CURRENCY</div>
  <div class="price-row" formGroupName="exchangeRates">
    <mat-form-field class="price-rate" floatLabel="always">
      <mat-label>EUR</mat-label>
      <input matInput type="number" min="0" step="0.0001" formControlName="EUR">
    </mat-form-field>
    <mat-form-field class="price-rate" floatLabel="always">
      <mat-label>JPY</mat-label>
      <input matInput type="number" min="0" step="0.0001" formControlName="JPY">
    </mat-form-field>
    <mat-form-field class="price-rate" floatLabel="always">
      <mat-label>CHF</mat-label>
      <input matInput type="number" min="0" step="0.0001" formControlName="CHF">
    </mat-form-field>
  </div>
  <p class="materials-hint">
    USD for 1 unit of the vendor currency. A frame can override the rate used for that conversion.
  </p>
  </div>
  <div class="settings-section" formArrayName="materials">
    <div class="settings-section-header">
      <span>MATERIALS</span>
      <button mat-stroked-button type="button" (click)="addMaterial()">ADD OPTION</button>
    </div>
    <p class="materials-hint">
      Options appear in the Material dropdown on Add Order. Selected material price is added to Custom.
    </p>

    <div
      class="material-row"
      *ngFor="let material of materials.controls; let i = index"
      [formGroupName]="i"
    >
      <mat-form-field class="material-label-field">
        <mat-label>LABEL</mat-label>
        <input matInput formControlName="label" autocomplete="off">
      </mat-form-field>
      <mat-form-field class="material-price-field">
        <mat-label>PRICE</mat-label>
        <span matPrefix>$&nbsp;</span>
        <input
          matInput
          type="text"
          inputmode="decimal"
          formControlName="price"
          autocomplete="off"
          (blur)="formatMaterialPrice(i)"
        >
      </mat-form-field>
      <button
        mat-icon-button
        type="button"
        color="warn"
        aria-label="Remove material option"
        (click)="removeMaterial(i)"
      >
        <mat-icon>delete</mat-icon>
      </button>
    </div>

    <div class="materials-empty" *ngIf="!materials.length">
      No material options yet. Click ADD OPTION to create one.
    </div>
  </div>

  <div class="settings-section" formArrayName="repairLocations">
    <div class="settings-section-header">
      <span>REPAIR LOCATIONS</span>
      <button mat-stroked-button type="button" (click)="addListOption('repairLocations')">ADD OPTION</button>
    </div>
    <p class="materials-hint">
      Used on Repair Tasks. Removing an option hides it from future jobs and does not change historical repairs.
    </p>
    <div
      class="material-row"
      *ngFor="let option of repairLocations.controls; let i = index"
      [formGroupName]="i"
    >
      <mat-form-field class="material-label-field">
        <mat-label>LABEL</mat-label>
        <input matInput formControlName="label" autocomplete="off">
      </mat-form-field>
      <mat-checkbox formControlName="active">ACTIVE</mat-checkbox>
      <button
        mat-icon-button
        type="button"
        color="warn"
        aria-label="Remove repair location"
        (click)="removeListOption('repairLocations', i)"
      >
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>

  <div class="settings-section" formArrayName="whoToCallOptions">
    <div class="settings-section-header">
      <span>WHO TO CALL</span>
      <button mat-stroked-button type="button" (click)="addListOption('whoToCallOptions')">ADD OPTION</button>
    </div>
    <p class="materials-hint">
      Used on CALL / RX. Historical jobs keep the originally selected value.
    </p>
    <div
      class="material-row"
      *ngFor="let option of whoToCallOptions.controls; let i = index"
      [formGroupName]="i"
    >
      <mat-form-field class="material-label-field">
        <mat-label>LABEL</mat-label>
        <input matInput formControlName="label" autocomplete="off">
      </mat-form-field>
      <mat-checkbox formControlName="active">ACTIVE</mat-checkbox>
      <button
        mat-icon-button
        type="button"
        color="warn"
        aria-label="Remove who to call option"
        (click)="removeListOption('whoToCallOptions', i)"
      >
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>

  <div class="settings-section">
    <div class="settings-section-header">FOLLOW-UP</div>
    <mat-form-field style="width:100%;">
      <input matInput type="number" min="1" step="1" formControlName="inquiryFollowUpHours" placeholder="INQUIRY FOLLOW-UP HOURS">
      <mat-hint>Hours before an unresolved Inquiry surfaces in TO DO TODAY. Default 24.</mat-hint>
    </mat-form-field>
    <mat-form-field style="width:100%;">
      <input matInput type="number" min="1" step="1" formControlName="awaitingRxFollowUpHours" placeholder="AWAITING RX FOLLOW-UP HOURS">
      <mat-hint>Hours before a missing RX surfaces as FOLLOW UP / RX. Default 24.</mat-hint>
    </mat-form-field>
  </div>

  <button mat-raised-button type="submit" [disabled]="pricingForm.invalid || saving">SAVE</button>
</form>
